import { useClientDetail } from './hooks';
import { convertToPresentationProps } from './logics';
import { ClientDetailPresentation } from './presentations';

type Props = {
  id: number;
};

/**
 * クライアント詳細のコンテナコンポーネント
 *
 * @param id - クライアントID（Screen 層でパース・検証済みの数値）
 */
export const ClientDetail: React.FC<Props> = ({ id }) => {
  const {
    state: { data, customFieldDefinitions, partnerFeatureFlags, tooltipId },
    actions: { handleShowTooltip, handleHideTooltip },
  } = useClientDetail(id);

  const presentationProps = convertToPresentationProps({
    data,
    customFieldDefinitions,
    partnerFeatureFlags,
  });

  return (
    <ClientDetailPresentation
      clientName={presentationProps.clientName}
      editLink={presentationProps.editLink}
      companyNameKana={presentationProps.companyNameKana}
      representativeName={presentationProps.representativeName}
      corporateNumber={presentationProps.corporateNumber}
      externalClientId={presentationProps.externalClientId}
      groupName={presentationProps.groupName}
      address={presentationProps.address}
      employeeCount={presentationProps.employeeCount}
      partnerBranchName={presentationProps.partnerBranchName}
      customFields={presentationProps.customFields}
      contractPlanName={presentationProps.contractPlanName}
      contractPlanLink={presentationProps.contractPlanLink}
      contractStartedOn={presentationProps.contractStartedOn}
      contactPersonName={presentationProps.contactPersonName}
      contactPersonNameKana={presentationProps.contactPersonNameKana}
      contactPersonEmail={presentationProps.contactPersonEmail}
      contactPersonPhone={presentationProps.contactPersonPhone}
      contactPreferredTime={presentationProps.contactPreferredTime}
      applicationNumber={presentationProps.applicationNumber}
      billingContactName={presentationProps.billingContactName}
      billingContactNameKana={presentationProps.billingContactNameKana}
      billingEmail={presentationProps.billingEmail}
      clientFeatureFlags={presentationProps.clientFeatureFlags}
      userCount={presentationProps.userCount}
      nonInvitedUserCount={presentationProps.nonInvitedUserCount}
      createdAt={presentationProps.createdAt}
      updatedAt={presentationProps.updatedAt}
      showTooltip={handleShowTooltip}
      hideTooltip={handleHideTooltip}
      tooltipId={tooltipId}
    />
  );
};
